var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 81.5,
    r: 81.5,
    fill: "url(#paint0_linear_3119_7870)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3119_7870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7598 99.3275L53.9031 84.4708C52.2476 82.8153 49.6158 82.8153 47.9604 84.4708C46.3049 86.1262 46.3049 88.758 47.9604 90.4135L65.746 108.199C67.4015 109.855 70.0757 109.855 71.7312 108.199L116.726 63.2468C118.381 61.5913 118.381 58.9596 116.726 57.3041C115.07 55.6486 112.439 55.6486 110.783 57.3041L68.7598 99.3275Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3119_7870",
    x1: 0,
    y1: 0,
    x2: 294.025,
    y2: 34.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3119_7870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.875,
    height: 101.875,
    fill: "white",
    transform: "translate(30.5625 30.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSvgrepoCom);
export default __webpack_public_path__ + "static/media/check-circle-svgrepo-com.63f1405fe4bed899f869edd757be44e7.svg";
export { ForwardRef as ReactComponent };